import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";
import { createRequestState, requestFailed, requestStarted, requestSucceeded } from "./requestState";

const slice = createSlice({
  name: "candidates",
  initialState: {
    list: [],
    loading: false,
    lastFetch: null,
    filterList: [],
    allFilterList: [],
    reminder: "",
    apps: [],
    parentApps: [],
    subProccessApps: [],
    addedUser: null,
    filterstatus: "",
    updatedStatus: null,
    bcDeleteStatus: null,
    bcDocDeleteStatus: null,
    bcAddEditStatus: null,
    localDocUploadSasUrl: null,
    latestIpcsId: 0,
    allCandidateList: [],
    backgroundChecks: [],
    checkIpcsId: null,
    candidateBprmForm: null,
    selectedCandidateObj: [],
    mailSentStatus: [],
    canByIdList: [],
    candidateNameList: [],
    currentWfTask: null,
    candidatePayDocUpload: null,
    candidatePayUpdateStatus: null,
    candidateInvoiceReviewStatus: null,
    candidateAdpDeductionStatus: null,
    requests: {
      list: createRequestState(),
      filter: createRequestState(),
      filterAll: createRequestState(),
      byId: createRequestState(),
      selectedFilter: createRequestState(),
      allList: createRequestState(),
      validateIpcsId: createRequestState(),
      names: createRequestState(),
      candidatePayDocUpload: createRequestState(),
      candidatePayUpdate: createRequestState(),
      candidateInvoiceReview: createRequestState(),
      candidateAdpDeduction: createRequestState(),
    },
  },
  reducers: {
    candidateRequestStarted: (candidates, action) => {
      requestStarted(candidates.requests, action.payload);
      if (action.payload === "filter") {
        candidates.filterList = [];
      }
      if (action.payload === "filterAll") {
        candidates.allFilterList = [];
      }
    },
    candidateRequestFailed: (candidates, action) => {
      requestFailed(candidates.requests, action.payload?.key, action.payload?.error || action.payload);
    },
    candidateAdded: (candidates, action) => {
      candidates.addedUser = action.payload;
      candidates.checkIpcsId = null;
    },
    candidateUpdated: (candidates, action) => {
      candidates.updatedStatus = action.payload;
      candidates.checkIpcsId = null;
    },
    candidatesReceived: (candidates, action) => {
      candidates.list = action.payload;
      candidates.reminder = "";
      candidates.addedUser = null;
      requestSucceeded(candidates.requests, "list");
    },
    filterCandidatesReceived: (candidates, action) => {
      candidates.filterList = action.payload;
      candidates.reminder = "";
      candidates.addedUser = null;
      requestSucceeded(candidates.requests, "filter");
    },
    filterAllCandidatesReceived: (candidates, action) => {
      candidates.allFilterList = action.payload;
      candidates.reminder = "";
      candidates.addedUser = null;
      requestSucceeded(candidates.requests, "filterAll");
    },
    filterAllCandidatesStatus: (candidates, action) => {
      candidates.filterstatus = action.payload;
    },
    reminderSent: (candidates, action) => {
      candidates.reminder = action.payload;
    },
    candidateAppsReceiving: (candidates, action) => {
      candidates.apps = [];
    },
    candidateAppsReceived: (candidates, action) => {
      candidates.apps = action.payload;
    },
    candidateParentAppsReceived: (candidates, action) => {
      candidates.parentApps = action.payload;
    },
    candidateSubProccessAppsReceived: (candidates, action) => {
      candidates.subProccessApps = action.payload;
    },
    candidateLatestIpcsIdReceived: (candidates, action) => {
      candidates.latestIpcsId = action.payload;
    },
    allCandidateListReceived: (candidates, action) => {
      candidates.allCandidateList = action.payload;
      requestSucceeded(candidates.requests, "allList");
    },
    backgroundChecksReceived: (candidates, action) => {
      candidates.backgroundChecks = action.payload;
      candidates.bcDeleteStatus = false;
      candidates.bcDocDeleteStatus = false;
      candidates.bcAddEditStatus = null;
      candidates.localDocUploadSasUrl = null;
    },
    addEditBcChecksReceived: (candidates, action) => {
      const payload = action.payload;
      if (!payload) {
        candidates.bcAddEditStatus = null;
        candidates.localDocUploadSasUrl = null;
        return;
      }

      candidates.bcAddEditStatus = payload.uploadId ?? payload;
      candidates.localDocUploadSasUrl = payload.sasUrls ?? null;
    },
    backgroundChecksDeleted: (candidates, action) => {
      candidates.bcDeleteStatus = action.payload;
    },
    bcDocDeleted: (candidates, action) => {
      candidates.bcDocDeleteStatus = action.payload;
    },
    checkedCandidateIpcsId: (candidates, action) => {
      candidates.checkIpcsId = action.payload;
      requestSucceeded(candidates.requests, "validateIpcsId");
    },
    candidateBprmFormReceived: (candidates, action) => {
      candidates.candidateBprmForm = action.payload;
    },
    selectedCandidateObjReceived: (candidates, action) => {
      candidates.selectedCandidateObj = action.payload;
      requestSucceeded(candidates.requests, "selectedFilter");
    },
    selectedCandidateObjReceiveClear: (candidates, action) => {
      candidates.selectedCandidateObj = [];
    },
    mailSentToCandidate: (candidates, action) => {
      candidates.mailSentStatus = action.payload;
    },
    receivedCandidateById: (candidates, action) => {
      candidates.canByIdList = action.payload;
      requestSucceeded(candidates.requests, "byId");
    },
    candidateNameListReceived: (candidates, action) => {
      candidates.candidateNameList = action.payload;
      requestSucceeded(candidates.requests, "names");
    },
    candidateCurrentWfTaskReceived: (candidates, action) => {
      candidates.currentWfTask = action.payload;
    },
    candidatePayDocUploaded: (candidates, action) => {
      candidates.candidatePayDocUpload = action.payload;
      requestSucceeded(candidates.requests, "candidatePayDocUpload", action.payload);
    },
    candidatePayUpdated: (candidates, action) => {
      candidates.candidatePayUpdateStatus = action.payload;
      requestSucceeded(candidates.requests, "candidatePayUpdate", action.payload);
    },
    candidateInvoiceReviewUpdated: (candidates, action) => {
      candidates.candidateInvoiceReviewStatus = action.payload;
      requestSucceeded(candidates.requests, "candidateInvoiceReview", action.payload);
    },
    candidateAdpDeductionUpdated: (candidates, action) => {
      candidates.candidateAdpDeductionStatus = action.payload;
      requestSucceeded(candidates.requests, "candidateAdpDeduction", action.payload);
    },
  },
});

export const {
  candidateAdded,
  candidateRequestStarted,
  candidateRequestFailed,
  candidatesReceived,
  filterCandidatesReceived,
  filterAllCandidatesReceived,
  filterAllCandidatesStatus,
  reminderSent,
  candidateAppsReceiving,
  candidateAppsReceived,
  candidateParentAppsReceived,
  candidateUpdated,
  candidateLatestIpcsIdReceived,
  allCandidateListReceived,
  candidateSubProccessAppsReceived,
  backgroundChecksReceived,
  addEditBcChecksReceived,
  backgroundChecksDeleted,
  bcDocDeleted,
  checkedCandidateIpcsId,
  candidateBprmFormReceived,
  selectedCandidateObjReceived,
  selectedCandidateObjReceiveClear,
  mailSentToCandidate,
  receivedCandidateById,
  candidateNameListReceived,
  candidateCurrentWfTaskReceived,
  candidatePayDocUploaded,
  candidatePayUpdated,
  candidateInvoiceReviewUpdated,
  candidateAdpDeductionUpdated,
} = slice.actions;
export default slice.reducer;

export const loadCandidates = (pageSize, currentPage, type) =>
  apiCallBegan({
    url:
      config.GetRegisteredApplicants +
      pageSize +
      "&pageNumber=" +
      currentPage +
      "&type=" +
      type,
    onStart: { type: candidateRequestStarted.type, payload: "list" },
    onSuccess: candidatesReceived.type,
    onError: { type: candidateRequestFailed.type, payload: { key: "list" } },
  });

export const loadCandidatesByFilter = (data) =>
  apiCallBegan({
    url: config.GetApplicantsByFilter,
    method: "post",
    data: data,
    onStart: { type: candidateRequestStarted.type, payload: "filter" },
    onSuccess: filterCandidatesReceived.type,
    onError: { type: candidateRequestFailed.type, payload: { key: "filter" } },
    cancelPrevious: true,
    cancelKey: "candidates/filter",
  });

export const loadAllCandidatesByFilter = (data) =>
  apiCallBegan({
    url: config.GetApplicantsByFilter,
    method: "post",
    data: data,
    onStart: { type: candidateRequestStarted.type, payload: "filterAll" },
    onSuccess: filterAllCandidatesReceived.type,
    onError: { type: candidateRequestFailed.type, payload: { key: "filterAll" } },
    cancelPrevious: true,
    cancelKey: "candidates/filter-all",
  });

export const loadCandidateById = (data) =>
  apiCallBegan({
    url: config.GetApplicantsByFilter,
    method: "post",
    data: data,
    onStart: { type: candidateRequestStarted.type, payload: "byId" },
    onSuccess: receivedCandidateById.type,
    onError: { type: candidateRequestFailed.type, payload: { key: "byId" } },
    cancelPrevious: true,
    cancelKey: "candidates/by-id",
  });

export const loadSelectedCandidatesByFilter = (data) =>
  apiCallBegan({
    url: config.GetApplicantsByFilter,
    method: "post",
    data: data,
    onStart: { type: candidateRequestStarted.type, payload: "selectedFilter" },
    onSuccess: selectedCandidateObjReceived.type,
    onError: { type: candidateRequestFailed.type, payload: { key: "selectedFilter" } },
    cancelPrevious: true,
    cancelKey: "candidates/selected-filter",
  });

export const loadCandidateApps = (id, type, userId, appId) =>
  apiCallBegan({
    url:
      config.GetApplicantApps +
      id +
      "&type=" +
      type +
      "&userId=" +
      userId +
      "&appId=" +
      appId,
    onStart: candidateAppsReceiving.type,
    onSuccess: candidateAppsReceived.type,
    cancelPrevious: true,
    cancelKey: "candidates/apps",
    dedupe: false,
  });

export const loadCandidateParentApps = (id, type, userId, appId) =>
  apiCallBegan({
    url:
      config.GetApplicantApps +
      id +
      "&type=" +
      type +
      "&userId=" +
      userId +
      "&appId=" +
      appId,
    onSuccess: candidateParentAppsReceived.type,
  });

export const loadCandidateSubProccessApps = (id, type, userId, appId) =>
  apiCallBegan({
    url:
      config.GetApplicantApps +
      id +
      "&type=" +
      type +
      "&userId=" +
      userId +
      "&appId=" +
      appId,
    onSuccess: candidateSubProccessAppsReceived.type,
  });

export const loadAllCandidateList = () =>
  apiCallBegan({
    url: config.GetAllCandidates,
    onStart: { type: candidateRequestStarted.type, payload: "allList" },
    onSuccess: allCandidateListReceived.type,
    onError: { type: candidateRequestFailed.type, payload: { key: "allList" } },
    cache: true,
    cacheDuration: 60000,
  });

export const SendReminder = (id) =>
  apiCallBegan({
    url: config.SendRemainderToApplicant + id,
    onSuccess: reminderSent.type,
  });

export const AddNewCandidate = (data) =>
  apiCallBegan({
    url: config.Registration,
    method: "post",
    data: data,
    onSuccess: candidateAdded.type,
  });

export const updateNewCandidate = (data) =>
  apiCallBegan({
    url: config.UpdateRegistration,
    method: "post",
    data: data,
    onSuccess: candidateUpdated.type,
  });

export const loadCandidateLatesIpcsId = () =>
  apiCallBegan({
    url: config.GetLatestIpcsId,
    onSuccess: candidateLatestIpcsIdReceived.type,
    dedupe: false,
  });

export const loadBackgroundChecks = (userId) =>
  apiCallBegan({
    url: config.GetBackgroundChecks + userId,
    onSuccess: backgroundChecksReceived.type,
  });

export const deleteBackgroundChecks = (id) =>
  apiCallBegan({
    url: config.DeleteBackgroundChecks + id,
    onSuccess: backgroundChecksDeleted.type,
  });

export const deleteBcDoc = (id) =>
  apiCallBegan({
    url: config.DeleteBcDoc + id,
    onSuccess: bcDocDeleted.type,
  });

export const AddEditBackgroundChecks = (data) =>
  apiCallBegan({
    url: config.AddEditBackgroundChecks,
    method: "post",
    data: data,
    onSuccess: addEditBcChecksReceived.type,
  });

export const checkCandidateIpcsId = (id) =>
  apiCallBegan({
    url: config.ValidateDuplicateIpcsId + id,
    onStart: { type: candidateRequestStarted.type, payload: "validateIpcsId" },
    onSuccess: checkedCandidateIpcsId.type,
    onError: { type: candidateRequestFailed.type, payload: { key: "validateIpcsId" } },
    cancelPrevious: true,
    cancelKey: "candidates/check-ipcs-id",
  });

export const loadCandidateBprmForm = (id) =>
  apiCallBegan({
    url: config.GetForm + id,
    onSuccess: candidateBprmFormReceived.type,
  });

export const sendMailToCandidate = (id) =>
  apiCallBegan({
    url: config.SendMailToNewlyAddedPerformer + id,
    onSuccess: mailSentToCandidate.type,
  });

export const loadCandidateNameList = (pmId) =>
  apiCallBegan({
    url: config.GetAllCandidatesNames + pmId,
    onStart: { type: candidateRequestStarted.type, payload: "names" },
    onSuccess: candidateNameListReceived.type,
    onError: { type: candidateRequestFailed.type, payload: { key: "names" } },
    cache: true,
    cacheDuration: 60000,
  });

export const loadCandidateWfTask = (id) =>
  apiCallBegan({
    url: config.GetApplicantCurrentWfTask + id,
    onSuccess: candidateCurrentWfTaskReceived.type,
  });

export const uploadCandidatePayDocument = (data) =>
  apiCallBegan({
    url: config.ApplicantUploadDocument,
    method: "post",
    data: data,
    onStart: { type: candidateRequestStarted.type, payload: "candidatePayDocUpload" },
    onSuccess: candidatePayDocUploaded.type,
    onError: { type: candidateRequestFailed.type, payload: { key: "candidatePayDocUpload" } },
    throwOnError: true,
  });

export const updateCandidateInvoicePayment = (data) =>
  apiCallBegan({
    url: config.UpdateInvoicePayment,
    method: "post",
    data: data,
    onStart: { type: candidateRequestStarted.type, payload: "candidatePayUpdate" },
    onSuccess: candidatePayUpdated.type,
    onError: { type: candidateRequestFailed.type, payload: { key: "candidatePayUpdate" } },
    throwOnError: true,
  });

export const updateCandidateInvoiceReview = (data) =>
  apiCallBegan({
    url: config.UpdateInvoiceReview,
    method: "post",
    data: data,
    onStart: { type: candidateRequestStarted.type, payload: "candidateInvoiceReview" },
    onSuccess: candidateInvoiceReviewUpdated.type,
    onError: { type: candidateRequestFailed.type, payload: { key: "candidateInvoiceReview" } },
    throwOnError: true,
  });

export const updateCandidateAdpDeduction = (data) =>
  apiCallBegan({
    url: config.UpdateAdpDeduction,
    method: "post",
    data: data,
    onStart: { type: candidateRequestStarted.type, payload: "candidateAdpDeduction" },
    onSuccess: candidateAdpDeductionUpdated.type,
    onError: { type: candidateRequestFailed.type, payload: { key: "candidateAdpDeduction" } },
    throwOnError: true,
  });

export const getAllCandidates = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.list,
);

export const getFilterAllCandidates = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.allFilterList,
);

export const getCandidateById = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.canByIdList,
);

export const getFilterCandidates = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.filterList,
);

export const getFilterCandidatesStatus = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.filterstatus,
);

export const getSelectedCandidateObj = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.selectedCandidateObj,
);

export const getReminderStatus = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.reminder,
);

export const getCandidateApps = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.apps,
);

export const getCandidateParentApps = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.parentApps,
);

export const getCandidateSubProccessApps = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.subProccessApps,
);

export const getAddedCandidate = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.addedUser,
);

export const getCandidateUpatedStatus = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.updatedStatus,
);

export const getCandidateLatestIpcsId = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.latestIpcsId,
);

export const getAllCandidateList = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.allCandidateList,
);

export const getBackgroundChecks = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.backgroundChecks,
);

export const getBcDeleteStatus = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.bcDeleteStatus,
);

export const getBcDocDeleteStatus = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.bcDocDeleteStatus,
);

export const getBcAddEditStatus = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.bcAddEditStatus,
);

export const getLocalDocUploadSasUrl = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.localDocUploadSasUrl,
);

export const getCheckIpcsIdStatus = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.checkIpcsId,
);

export const getCandidateBprmForm = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.candidateBprmForm,
);

export const getCandidateNameList = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.candidateNameList,
);

export const getCandidateCurrentWfTask = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.currentWfTask,
);

export const getCandidateRequests = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.requests,
);

export const getCandidatePayDocUpload = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.candidatePayDocUpload,
);

export const getCandidatePayUpdateStatus = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.candidatePayUpdateStatus,
);

export const getCandidateInvoiceReviewStatus = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.candidateInvoiceReviewStatus,
);

export const getCandidateAdpDeductionStatus = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.candidateAdpDeductionStatus,
);
